(() => {
  function revealLinkedDetail() {
    if (!location.hash.startsWith('#hfc-gb-')) return;
    const target = document.getElementById(location.hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#hfc-gb-holiday-info"]');
    if (link) document.getElementById('hfc-gb-holiday-info').open = true;
  });
  window.addEventListener('hashchange', revealLinkedDetail);
  revealLinkedDetail();
})();